import common from './en/common.json';
import errors from './en/errors.json';

export const coreResources = {
  en: { common, errors },
} as const;
